import { globalTestArray } from '../GlobalModule';
// console.log('Module.ts loaded, globalTestArray from GlobalModule imported, first member' + globalTestArray[0]);
